import React, {Component} from "react";
import axios from "axios";
import language from "./language";
import {Link} from "react-router-dom";

class Services extends Component {
    state: { language: string; text: string; title: string; list: any[] };

    constructor(props: any) {
        super(props)

        const lang = language()
        const baseUrl = process.env.REACT_APP_API_URL + "/getPage/" + process.env.REACT_APP_SITE_NAME + "/" + lang + "/services";

        this.state = {
            title: '',
            text: '',
            list: [],
            language: lang
        }
        this.post = this.post.bind(this)
        this.get_blog_list = this.get_blog_list.bind(this)

        this.post(baseUrl)
        this.get_blog_list(4);
    }

    post(url: string) {
        const headers = {
            "Content-Type": "application/json",
        };

        // @ts-ignore
        axios.get(url, headers)
            .then(response => {
                    this.setState({
                        title: response.data.title,
                        text: response.data.text,
                        id: response.data.id,
                        date: response.data.date_string
                    })
                }
            )
            .catch(error => {
                console.log(error)
            });
    }

    get_blog_list(count: string | number) {
        const headers = {
            "Content-Type": "application/json",
        };

        const url = `${process.env.REACT_APP_API_URL}/getBlogs/${process.env.REACT_APP_SITE_NAME}/any/${count}`

        // @ts-ignore
        axios.get(url, headers)
            .then(response => {
                    this.setState({
                        list: Array.from(response.data),
                    })
                    window.scrollTo(0, 0)
                }
            )
            .catch(error => {
                console.log(error)
            });
    }


    render() {

        const title = this.state.title;
        const text = this.state.text;

        const list = this.state.list
        let  blog_list = list.map((item) =>
            <div key={item.id}>
                <div className='blog_list_item mt-3 ml-3 mr-3'><Link to={'/blog/' + item.id}>{item.title}</Link>
                    <div className='date_string'> {(item.date_string !== undefined && item.date_string.length > 10) ? item.date_string.substring(0, 10) : ''}</div>
                </div>
            </div>
        );

        return (

            <div className="float-container">
                <div className="float-child-left">
                    <div className='home-content'>
                        <h2>  {title}  </h2>
                        <div dangerouslySetInnerHTML={{__html: text}}/>
                    </div>

                </div>
                <div className="float-child-right">
                    <div id="sidebar-wrapper">
                        <p className="sidebar-blogs">
                            <div id='linkContainer' className='ml-0'>
                                <p className='mt-5'>&nbsp;</p>
                                <div className='mt-5'>{blog_list}</div>
                            </div>
                        </p>
                    </div>

                </div>

            </div>
        )
            ;
    }
}


export default Services
